import ReactHtmlParser from "react-html-parser";
export const yoastHeaderHelper = (res) => {
  let regex = new RegExp(process.env.REACT_APP_BASE_URL, "g");
  const yoast = res?.replace(regex, window.location.origin);
  return ReactHtmlParser(yoast);
};
